// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
}

.popup-container {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 100%;
  background: linear-gradient(135deg, rgb(255 255 255 / 60%), rgb(240 240 240 / 60%));
  padding: 40px 20px;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.close-button {
  position: absolute;
  top: 55px;
  right: 30px;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 50%;
  font-size: 28px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  z-index: 10;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.close-button:hover {
  background: white;
  transform: scale(1.1);
}

.popup-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  width: 100%;
}

.popup-title {
  font-size: 42px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.subscription-options {
  display: flex;
  justify-content: center;
  gap: 30px;
  width: 100%;
  flex-wrap: wrap;
  padding: 20px;
}

.subscription-card {
  position: relative;
  background-color: white;
  border-radius: 15px;
  padding: 25px 20px;
  width: 300px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s, box-shadow 0.3s;
  height: 480px;
}

.subscription-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
}

.iphone-only-tag {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #f0f0f0;
  color: #333;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.discount-tag {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #6c5ce7;
  color: white;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.subscription-type {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #555;
}

.price {
  font-size: 25px;
  font-weight: bold;
  color: #00a67e;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.original-price {
  font-size: 18px;
  color: #999;
  text-decoration: line-through;
}

.credits {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
}

.coin-icon {
  font-size: 18px;
  color: #888;
}

.credit-period {
  color: #888;
  font-size: 14px;
  margin-left: 5px;
}

.qr-container {
  width: 100%;
  height: 0;
  overflow: hidden;
  transition: height 0.5s ease-in-out;
  opacity: 0;
  margin-bottom: 0;
}

.qr-container.show-qr {
  height: 100%;
  opacity: 1;
  margin-bottom: 20px;
  animation: slideDown 0.5s ease-in-out;
}
.qr-container.hide-qr {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
  animation: slideUp 0.5s ease-in-out;
}

.features {
  width: 100%;
  margin-bottom: 20px;
  height: 100%;
  overflow: hidden;
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
  opacity: 1;
}

.features.hide-features {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
  animation: slideUp 0.5s ease-in-out;
}

@keyframes slideDown {
  from {
    height: 0;
    opacity: 0;
  }
  to {
    height: 200px;
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    max-height: 200px;
    opacity: 1;
  }
  to {
    max-height: 0;
    opacity: 0;
  }
}

.feature-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.feature-text {
  color: #666;
}

.check-icon {
  color: #00a67e;
  font-weight: bold;
}

.subscription-button {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 30px;
  background: linear-gradient(90deg, rgb(195 13 255) 0%, rgb(13, 134, 255) 50%, rgb(124, 200, 244) 100%);
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
  transition: transform 0.2s;
}

.iphone-button {
  background: white;
  border: 1px solid #ddd;
  color: #333;
}

.subscription-button:hover {
  transform: translateY(-2px);
}

.subscription-note {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  text-align: center;
}

/* Tablet Devices */
@media (max-width: 768px) {
  .subscription-options {
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }
  
  .subscription-card {
    width: 100%;
    max-width: 350px;
    margin-bottom: 20px;
  }
  
  .popup-title {
    font-size: 32px;
    padding: 0 15px;
    margin-bottom: 30px;
  }
  
  .popup-container {
    padding: 30px 15px;
    align-items: flex-start;
  }
  
  .popup-content {
    padding-top: 60px;
  }
  
  .close-button {
    top: 45px;
    right: 20px;
  }
}

/* Mobile Devices - Medium */
@media (max-width: 576px) {
  .popup-title {
    font-size: 25px;
    margin-bottom: 25px;
  }
  
  .subscription-card {
    padding: 20px 15px;
  }
  
  .price {
    font-size: 36px;
  }
  
  .subscription-type {
    font-size: 22px;
  }
  
  .popup-container {
    padding: 20px 10px;
  }
  
  .close-button {
    width: 36px;
    height: 36px;
    font-size: 24px;
  }
}

/* Mobile Devices - Small */
@media (max-width: 375px) {
  .popup-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .subscription-card {
    padding: 15px 12px;
  }
  
  .price {
    font-size: 32px;
  }
  
  .original-price {
    font-size: 16px;
  }
  
  .subscription-type {
    font-size: 20px;
  }
  
  .feature-item {
    padding: 8px 0;
  }
  
  .feature-text {
    font-size: 14px;
  }
  
  .credits {
    font-size: 14px;
  }
  
  .subscription-button {
    padding: 10px;
    font-size: 14px;
  }
  
  .close-button {
    width: 32px;
    height: 32px;
    font-size: 20px;
    top: 10px;
    right: 10px;
  }
}

/* Landscape orientation for mobile devices */
@media (max-height: 500px) and (orientation: landscape) {
  .popup-container {
    padding: 10px;
    overflow-y: auto;
  }
  
  .popup-title {
    font-size: 22px;
    margin-bottom: 15px;
  }
  
  .subscription-options {
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    padding: 10px 5px;
    gap: 15px;
  }
  
  .subscription-card {
    min-width: 250px;
    padding: 15px 10px;
    margin-bottom: 10px;
  }
  
  .close-button {
    top: 5px;
    right: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Popup/SubscriptionPopup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mFAAmF;EACnF,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iEAAiE;EACjE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,sGAAsG;EACtG,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,WAAW;EACb;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF","sourcesContent":[".popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(8px);\n}\n\n.popup-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  background: linear-gradient(135deg, rgb(255 255 255 / 60%), rgb(240 240 240 / 60%));\n  padding: 40px 20px;\n  overflow: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.close-button {\n  position: absolute;\n  top: 55px;\n  right: 30px;\n  background: rgba(255, 255, 255, 0.8);\n  border: none;\n  border-radius: 50%;\n  font-size: 28px;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #333;\n  z-index: 10;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.close-button:hover {\n  background: white;\n  transform: scale(1.1);\n}\n\n.popup-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 1200px;\n  width: 100%;\n}\n\n.popup-title {\n  font-size: 42px;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 40px;\n  color: #fff;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.subscription-options {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n  width: 100%;\n  flex-wrap: wrap;\n  padding: 20px;\n}\n\n.subscription-card {\n  position: relative;\n  background-color: white;\n  border-radius: 15px;\n  padding: 25px 20px;\n  width: 300px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: transform 0.3s, box-shadow 0.3s;\n  height: 480px;\n}\n\n.subscription-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);\n}\n\n.iphone-only-tag {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: #f0f0f0;\n  color: #333;\n  padding: 4px 8px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.discount-tag {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: #6c5ce7;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.subscription-type {\n  font-size: 24px;\n  font-weight: 500;\n  margin-bottom: 10px;\n  color: #555;\n}\n\n.price {\n  font-size: 25px;\n  font-weight: bold;\n  color: #00a67e;\n  margin-bottom: 5px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.original-price {\n  font-size: 18px;\n  color: #999;\n  text-decoration: line-through;\n}\n\n.credits {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 20px;\n  font-size: 16px;\n  color: #666;\n}\n\n.coin-icon {\n  font-size: 18px;\n  color: #888;\n}\n\n.credit-period {\n  color: #888;\n  font-size: 14px;\n  margin-left: 5px;\n}\n\n.qr-container {\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.5s ease-in-out;\n  opacity: 0;\n  margin-bottom: 0;\n}\n\n.qr-container.show-qr {\n  height: 100%;\n  opacity: 1;\n  margin-bottom: 20px;\n  animation: slideDown 0.5s ease-in-out;\n}\n.qr-container.hide-qr {\n  max-height: 0;\n  opacity: 0;\n  margin-bottom: 0;\n  animation: slideUp 0.5s ease-in-out;\n}\n\n.features {\n  width: 100%;\n  margin-bottom: 20px;\n  height: 100%;\n  overflow: hidden;\n  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;\n  opacity: 1;\n}\n\n.features.hide-features {\n  max-height: 0;\n  opacity: 0;\n  margin-bottom: 0;\n  animation: slideUp 0.5s ease-in-out;\n}\n\n@keyframes slideDown {\n  from {\n    height: 0;\n    opacity: 0;\n  }\n  to {\n    height: 200px;\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    max-height: 200px;\n    opacity: 1;\n  }\n  to {\n    max-height: 0;\n    opacity: 0;\n  }\n}\n\n.feature-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.feature-text {\n  color: #666;\n}\n\n.check-icon {\n  color: #00a67e;\n  font-weight: bold;\n}\n\n.subscription-button {\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: 30px;\n  background: linear-gradient(90deg, rgb(195 13 255) 0%, rgb(13, 134, 255) 50%, rgb(124, 200, 244) 100%);\n  color: #fff;\n  font-weight: bold;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n  transition: transform 0.2s;\n}\n\n.iphone-button {\n  background: white;\n  border: 1px solid #ddd;\n  color: #333;\n}\n\n.subscription-button:hover {\n  transform: translateY(-2px);\n}\n\n.subscription-note {\n  margin-top: 10px;\n  font-size: 12px;\n  color: #999;\n  text-align: center;\n}\n\n/* Tablet Devices */\n@media (max-width: 768px) {\n  .subscription-options {\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n  }\n  \n  .subscription-card {\n    width: 100%;\n    max-width: 350px;\n    margin-bottom: 20px;\n  }\n  \n  .popup-title {\n    font-size: 32px;\n    padding: 0 15px;\n    margin-bottom: 30px;\n  }\n  \n  .popup-container {\n    padding: 30px 15px;\n    align-items: flex-start;\n  }\n  \n  .popup-content {\n    padding-top: 60px;\n  }\n  \n  .close-button {\n    top: 45px;\n    right: 20px;\n  }\n}\n\n/* Mobile Devices - Medium */\n@media (max-width: 576px) {\n  .popup-title {\n    font-size: 25px;\n    margin-bottom: 25px;\n  }\n  \n  .subscription-card {\n    padding: 20px 15px;\n  }\n  \n  .price {\n    font-size: 36px;\n  }\n  \n  .subscription-type {\n    font-size: 22px;\n  }\n  \n  .popup-container {\n    padding: 20px 10px;\n  }\n  \n  .close-button {\n    width: 36px;\n    height: 36px;\n    font-size: 24px;\n  }\n}\n\n/* Mobile Devices - Small */\n@media (max-width: 375px) {\n  .popup-title {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n  \n  .subscription-card {\n    padding: 15px 12px;\n  }\n  \n  .price {\n    font-size: 32px;\n  }\n  \n  .original-price {\n    font-size: 16px;\n  }\n  \n  .subscription-type {\n    font-size: 20px;\n  }\n  \n  .feature-item {\n    padding: 8px 0;\n  }\n  \n  .feature-text {\n    font-size: 14px;\n  }\n  \n  .credits {\n    font-size: 14px;\n  }\n  \n  .subscription-button {\n    padding: 10px;\n    font-size: 14px;\n  }\n  \n  .close-button {\n    width: 32px;\n    height: 32px;\n    font-size: 20px;\n    top: 10px;\n    right: 10px;\n  }\n}\n\n/* Landscape orientation for mobile devices */\n@media (max-height: 500px) and (orientation: landscape) {\n  .popup-container {\n    padding: 10px;\n    overflow-y: auto;\n  }\n  \n  .popup-title {\n    font-size: 22px;\n    margin-bottom: 15px;\n  }\n  \n  .subscription-options {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    justify-content: flex-start;\n    padding: 10px 5px;\n    gap: 15px;\n  }\n  \n  .subscription-card {\n    min-width: 250px;\n    padding: 15px 10px;\n    margin-bottom: 10px;\n  }\n  \n  .close-button {\n    top: 5px;\n    right: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
